import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index'
Vue.use(Vuex)
const store = new Vuex.Store({

    /** 全局变量*/
    
    state: localStorage.getItem("state") ? JSON.parse(localStorage.getItem("state")): {
      user: {
        id:'',
        username: '',
      },
      typeid:'',
      active:'',
      tenantCode:510100,
      allDictType:[],//字典
      cityregion:[],//区域
      BussileList:[],//商圈
      ticketList:[],//地铁
    },
  
    getters: {
   
    },
    mutations: {
      updateAllDictType(state, newDictType) {
        console.log("updateAllDictType")
        state.allDictType = newDictType;
        localStorage.setItem("state", JSON.stringify(state));
    },
      getRegion(state,num){
        // console.log('staea', state,num)
        state.cityregion=num
      },
      allBussileList(state,num){
        // console.log('staea', state,num)
        state.BussileList=num
      },
      ticketList(state,num){
        state.ticketList=num
      },
      setType(state,num){
        console.log('staea43',num)
        state.typeid=num
      },
      setActive(state,num){
       console.log('staea47',num)
        state.active=num
      }
    },
    actions: {
  
    }
  
  })
  export default store


// WEBPACK FOOTER //
// ./src/store/store.js